export default {
  MuiTypography: {
    paragraph: {
      marginBottom: "30px"
    }
  }
};
